import { IntlShape, useIntl } from 'react-intl';

export function describeDate(intl: IntlShape, startTime: string) {
    return intl.formatDate(startTime, {
        day: 'numeric',
        month: 'long',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'long',
    });
}

export function useDescribedDate(startTime: string) {
    return describeDate(useIntl(), startTime);
}
